<script setup lang="ts">
import useLocale from '../../composables/useLocale';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMessageLines, faPlay, faTrash, faHighlighter, faXmark } from '@fortawesome/pro-regular-svg-icons';

library.add(faMessageLines, faPlay, faTrash, faHighlighter, faXmark);

type Emits = {
  (e: 'play'): void;
  (e: 'openNote'): void;
  (e: 'delete'): void;
  (e: 'close'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  hasMediaAvailable?: boolean;
  showDelete?: boolean;
  isRemoving?: boolean;
  hasComment?: boolean;
};
withDefaults(defineProps<Props>(), {
  hasMediaAvailable: false,
  showDelete: false,
  isRemoving: false,
  hasComment: false,
});

const { t } = useLocale();
</script>

<template>
  <div class="d-flex align-center ga-1">
    <v-btn
      v-if="hasMediaAvailable"
      variant="text"
      color="on-inverse-surface"
      icon
      size="44"
      :title="t('book_player.label_play_from_sentence')"
      @click="emit('play')"
    >
      <FontAwesomeIcon icon="far fa-play" size="lg" />
    </v-btn>
    <v-btn
      variant="text"
      color="on-inverse-surface"
      icon
      size="44"
      :title="
        hasComment ? t('book_player.label_annotation_edit_comment') : t('book_player.label_annotation_add_comment')
      "
      @click="emit('openNote')"
    >
      <FontAwesomeIcon icon="far fa-message-lines" size="lg" />
    </v-btn>
    <v-divider v-if="showDelete" vertical class="mx-1 action-divider" color="outline-variant" />
    <v-btn
      v-if="showDelete"
      variant="text"
      color="on-inverse-surface"
      icon
      size="44"
      :loading="isRemoving"
      :title="t('button_delete')"
      @click="emit('delete')"
    >
      <FontAwesomeIcon icon="far fa-trash" size="lg" />
    </v-btn>
    <v-divider vertical class="mx-1 action-divider" color="outline-variant" />
    <v-btn variant="text" color="on-inverse-surface" icon size="44" :title="t('button_cancel')" @click="emit('close')">
      <FontAwesomeIcon icon="far fa-xmark" size="lg" />
    </v-btn>
  </div>
</template>

<style scoped lang="scss">
.action-divider {
  height: 24px;
  align-self: center;
}
</style>
